import { useState } from "react";
import { IADPState } from "../typings/AppStateTypes";
import { useSelector } from "react-redux";
import { ScreenDialogue,useDedupEffect } from "@npd-ng/adp-component-library";

export function ModeSwitchConfirmation() {
    const state = useSelector((state:{rootState:IADPState})=>state.rootState)
    const [visible, setVisible] = useState(false);
    const currentMoode = state.appState.launchMode;
    const newMode:IADPState["appState"]["launchMode"] = currentMoode === "Internet" ? "NPN" : "Internet";
    const msg = `App is running in ${currentMoode} mode. Would you like to switch to ${newMode} mode?`
    function handleKeydown(event: { ctrlKey: any; key: string; preventDefault: () => void; }) {
        // Check if the Ctrl key and the 'm' key are pressed
        if (event.ctrlKey && event.key === 'u') {
            // Prevent the default action if needed
            event.preventDefault(); 
            // Perform your custom action here
            console.log('Ctrl+u was pressed!');
            setVisible(true);
        }
    }
    const cancelConfirmationModal = ()=>{
        setVisible(false);
    }
    const submitConfirmationModal = ()=>{
        if(state.appState.launchMode){
            const pathname = window.location.pathname.split("/");
            const origin = window.location.origin;
            const newLocation =  `${origin}/${pathname[1]}/${state.appState.launchMode === "Internet" ? "npn/index.html" : "index.html"}`
            window.location.replace(newLocation);
        }
        else {
            setVisible(false);
        }
    }
    useDedupEffect(()=>{
        document.addEventListener('keydown', handleKeydown);
        return () => {
            document.removeEventListener('keydown', handleKeydown);
          };
    },[])
    return (
        <>
         {visible && 
        <ScreenDialogue
            title="Mode Switch"
            subTitle={msg}
            confirmText='Yes'
            cancelText="No"
            onCancelAction={cancelConfirmationModal}
            onSubmitAction={submitConfirmationModal}
          ></ScreenDialogue>
        }
        </>
    )
}